import React from 'react';
import PropTypes from 'prop-types';
import CustomerApprovalPdfViewer from './CustomerApprovalPdfViewer';
import { Button } from 'reactstrap';
import { customerApprovalDocumentLookupServices } from '@ami/react/shared';
import RevisionDocumentListModalComponent from './RevisionDocumentListModalComponent';

class CustomerApprovalDocumentItem extends React.Component {
  constructor(props) {
    super(props);
    this.download = this.download.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
    this.handleHideRevisionDocumentListModal =
      this.handleHideRevisionDocumentListModal.bind(this);
    this.onDownLoad = this.onDownLoad.bind(this);
  }

  static propTypes = {
    entity: PropTypes.object.isRequired,
    document: PropTypes.object.isRequired,
  };

  state = {
    isDownloading: false,
    showRevisionDocumentListModal: false,
    documentIdDownloading: null,
    watermarkGenerated: undefined,
  };

  componentDidMount = async () => {
    this.setState({
      watermarkGenerated: this.props.document.watermarkGenerated,
    });
  };

  download = async () => {
    this.setState({ isDownloading: true });
    customerApprovalDocumentLookupServices
      .getDownloadUrl(this.props.entity.id, this.props.document.id)
      .then((response) => (window.location = response.url))
      .finally(() => this.setState({ isDownloading: false }));
  };

  downloadDocument() {
    this.setState({ showRevisionDocumentListModal: true });
    this.setState({ documentIdDownloading: this.props.document.id });
  }

  handleHideRevisionDocumentListModal() {
    this.setState({ showRevisionDocumentListModal: false });
    this.setState({ documentIdDownloading: null });
  }

  onDownLoad(watermarkGenerated) {
    this.setState({ watermarkGenerated: watermarkGenerated });
  }

  render() {
    const { document, entity } = this.props;
    const {
      documentIdDownloading,
      showRevisionDocumentListModal,
      isDownloading,
      watermarkGenerated,
    } = this.state;

    return (
      <div key={document.id}>
        {!watermarkGenerated && (
          <div className="row justify-content-right">
            <div className="col">
              <h5 className="text-break-line">
                Document is being processed, please try again shortly
              </h5>
            </div>
            <div className="row">
              <div className="col-12">
                Loading... <i className="fa fa-spin fa-spinner" />
              </div>
            </div>
          </div>
        )}
        {watermarkGenerated && (
          <div className="text-end">
            <Button
              title={isDownloading ? 'Downloading' : 'Download Document'}
              type="button"
              color="primary"
              onClick={() => this.download()}
              className="m-1 ms-3"
            >
              {isDownloading && <i className="fa fa-spin fa-spinner" />}
              {!isDownloading && <div>Download PDF</div>}
            </Button>
            <Button
              type="button"
              color="primary"
              onClick={() => this.downloadDocument()}
              className="m-1 ms-3"
            >
              View Revisions
            </Button>
          </div>
        )}
        <div className="pdfviewer__container__document">
          <CustomerApprovalPdfViewer
            customerApprovalId={entity.id}
            documentId={document.id}
            onDownLoad={this.onDownLoad}
          />
        </div>
        {documentIdDownloading && (
          <RevisionDocumentListModalComponent
            entity={entity}
            documentId={documentIdDownloading}
            showModal={showRevisionDocumentListModal}
            hideModal={this.handleHideRevisionDocumentListModal}
          />
        )}
      </div>
    );
  }
}

export default CustomerApprovalDocumentItem;
